export type PublicOfferKey = "protection_free" | "hosting_basic";

export interface PublicOffer {
  key: PublicOfferKey;
  label: string;
  status: string;
  title: string;
  priceLabel: string;
  description: string;
  features: string[];
  note: string;
  lifecycle?: string[];
}

export const PUBLIC_OFFERS: PublicOffer[] = [
  {
    key: "protection_free",
    label: "ShadowScan Guard",
    status: "Available",
    title: "Free WordPress protection layer",
    priceLabel: "Free",
    description:
      "Essential local hardening and basic status visibility through ShadowScan Guard. No hosting, no ShadowScan team monitoring, and no analyst-led response.",
    features: [
      "Essential local WordPress hardening where supported",
      "Basic status and self-check visibility in WordPress",
      "Safe, reversible controls inside the official ShadowScan Security Link plugin",
      "No managed monitoring, analyst response, or hosting included",
    ],
    note:
      "ShadowScan Guard is limited to essential local hardening and basic visibility. It does not include ShadowScan team monitoring, analyst-led response, a file-level firewall, or malware-signature scanning.",
  },
  {
    key: "hosting_basic",
    label: "Basic Hosting",
    status: "Available",
    title: "Managed WordPress hosting with ShadowScan Guard onboarding",
    priceLabel: "AUD 12.99 / month",
    description:
      "Hosted WordPress onboarding provisioned through cPanel, WHM, and WHMCS. ShadowScan Guard onboarding is included, and Basic Hosting can be paired with Essential or Premium as a security add-on.",
    features: [
      "cPanel reseller provisioning and customer handoff through WHMCS",
      "WordPress install or connection step before protection can go live",
      "Official ShadowScan Security Link plugin used during WordPress setup",
      "Plugin installation is required before pairing and the first live heartbeat",
      "ShadowScan Guard pairing and activation after provisioning",
      "Add Essential or Premium when you want monitored or analyst-led security on top of hosting",
    ],
    note:
      "Hosting-only does not include ShadowScan team monitoring, analyst-led response, a file-level WAF, malware-signature scanning, or managed plugin-feature unlocks on its own. Add Essential or Premium when you need managed security with hosting.",
    lifecycle: [
      "ordered",
      "hosting_provisioned",
      "wordpress_installed_or_connected",
      "plugin_paired",
      "guards_live",
    ],
  },
];
